import { useState } from "react";
import "leaflet/dist/leaflet.css";
import { ParameterProvider } from "./types/ParameterContext";
import { MapSyncProvider } from "./types/MapSyncContext";
import { ClickProvider } from "./types/ClickContext";
import MainPanel from "./components/MainPanel";

export default function App() {

  

  return (
     <div className="relative min-h-screen w-full overflow-y-auto bg-gray-50">
      <ParameterProvider>
        <MapSyncProvider>
          <ClickProvider>
            <MainPanel/>
          </ClickProvider>
        </MapSyncProvider>
      </ParameterProvider>
     </div>
  );
}
